import { EntityDetailTableProps } from "../common/entity/EntityInterfaces";
import { Table } from "../common/panels/Detail/DetailTable";
import { NotAvailable, NotSet } from "../common/misc/UIconstants";
import { toUppercase } from "../common/helperfunctions/stringFunctions";
import { CustomTypeDetailRow, CustomTypeRenderer } from "../Customization/CustomTypes/generics/CustomTypeRenderer";
import { GetProjects } from "../common/misc/EntityRenders/EntityRenderer";
import { DateTimeRenderer } from "../common/datetime/DateTimeFormatter";

export interface DatasetDetailTableProps extends EntityDetailTableProps<"datasets"> {
  hideHeader?: boolean;
  hideAutomaticallyGeneratedFields?: boolean;
}

export const DatasetsDetailTable = ({
  entity: dataset,
  entityConstants,
  entityTypeId,
  fieldLabels,
  hideHeader = false,
  showLinks = true,
  hideAutomaticallyGeneratedFields = false,
}: DatasetDetailTableProps) => {
  return (
    <>
      <Table noPadding nonFoldable>
        {!hideHeader && <Table.Head>Details</Table.Head>}
        <Table.Body>
          <Table.Body.RowContent
            title={fieldLabels.name}
            content={
              <div className="container_label">
                <div className="container_label_name" style={{ fontWeight: 600 }}>
                  {dataset.name ?? NotSet}
                </div>
                {!hideAutomaticallyGeneratedFields && (
                  <div className="container_label_id">
                    <span style={{ whiteSpace: "nowrap" }}>
                      {toUppercase(entityConstants.entitySingular)}-ID: {dataset.id ?? NotAvailable}
                    </span>
                  </div>
                )}
              </div>
            }
          />

          <CustomTypeDetailRow entity={dataset} entityTypeId={entityTypeId} showLinks={showLinks} />

          {!hideAutomaticallyGeneratedFields && (
            <Table.Body.RowContent
              title={fieldLabels.creationDate}
              content={dataset.creationDate ? <DateTimeRenderer date={dataset.creationDate} /> : NotSet}
            />
          )}

          <Table.Body.RowContent
            title={fieldLabels.projects}
            content={<GetProjects projects={dataset.projects} createLinks={showLinks} />}
          />
        </Table.Body>
      </Table>
      <CustomTypeRenderer entity={dataset} showLinks={showLinks} />
    </>
  );
};
